<template>
  <div class="citysApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div>
      <h2 style="background:#fff">当前选择</h2>
      <div><font style="color:#FE506A" @click="chooseCitys(cityData.cityCode,cityData.cityName)">{{cityData.cityName}}</font></div>
      <h2 style="background:#fff">当前位置</h2>
      <div><font @click="chooseCitys(cityData.cityCode,cityData.cityName)">{{cityData.cityName}}</font></div>

      <div v-for="(item,i) in setCitys">
        <h2>{{i}}</h2>
        <ul>
          <li v-for="(vo,k) in item" @click="chooseCitys(vo.cityCode,vo.cityName)">{{vo.cityName}}</li>
        </ul>
      </div>
    </div>
  </div>
  
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        code:'',
        setCitys:[],
        cityData:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('user') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/citys');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }

    },
    mounted() {
      if(localStorage.getItem('user') == null){
        this.login();
      }else{
        var cCode = JSON.parse(localStorage.getItem('cCode'));
        this.cityData = cCode;
        this.getCitys()
      }
      this.beforeMount();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      chooseCitys:function(cityCode,cityName){
        var expires = Date.parse(new Date()) / 1000;
          expires = (expires + 300) * 1000;
        var data = {
          cityCode:cityCode,
          cityName:cityName,
          expires:expires
        };
        localStorage.setItem('cCode', JSON.stringify(data));
        this.$router.go(-1);
      },
      getCitys:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/movies/cities',
          dataType:'json',
          success:function(data){
            that.setCitys = data.data;
            that.fullscreenLoading = false;
          }
        })
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('user', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .citysApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .citysApp h2{
    margin:0 auto;
    font-size:18px;
    padding:10px 4%
  }
  .citysApp ul{
    background:#fff;
  }
  .citysApp ul li{
    width:92%;
    margin:0 auto;
    height:50px;
    line-height:50px;
  }
  .citysApp font{
    display:inline-block;
    padding:8px 20px;
    background:#fff;
    border-radius:10px;
    font-size:15px;
    margin:15px 4%
  }
</style>